import _ from 'lodash';

import { ACTIONS } from '../config/constants';

export function updateStatAttribute(params) {
  return (dispatch, getState) => {
    const state = getState();
    const questionId = state.quiz.questions[state.quiz.currentQuestionIndex].id;
    params.questionId = questionId;

    dispatch({
      type: ACTIONS.TYPES.QUESTION_STATS.UPDATE_ATTRIBUTE_INITIALIZED
    });
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_updateAccountStat/`,
      {
        params,
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : state.auth.accessToken
          }`
        }
      }
    ).then(res => {
      const quiz = _.cloneDeep(getState().quiz);
      quiz.questions = quiz.questions.map(q =>
        Object.assign(q, { lastAttemptCorrect: isLastAttemptCorrect(q) })
      );
      quiz.correctCount = quiz.questions.reduce(
        (tot, q) => (q.lastAttemptCorrect ? tot + 1 : tot),
        0
      );
      if (state.filtered && state.filtered.quizzes) {
        const historyQuizIndex = state.filtered.quizzes.reduce(
          (idx, q, i) => (q.id === quiz.id ? i : idx),
          -1
        );

        const updatedQuizzes = _.cloneDeep(state.filtered.quizzes);

        if (historyQuizIndex > -1) {
          updatedQuizzes.splice(historyQuizIndex, 1, quiz);
        } else {
          updatedQuizzes.unshift(quiz);
        }

        dispatch({
          type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS,
          history: { quizzes: updatedQuizzes }
        });
      }

      dispatch({
        type: ACTIONS.TYPES.QUESTION_STATS.UPDATE_ATTRIBUTE_SUCCESS,
        attribute: params
      });
    });
  };
}

export function submitResponse() {
  return (dispatch, getState) => {
    const state = getState();
    const quiz = state.quiz;
    const question = quiz.questions[quiz.currentQuestionIndex];

    const {
      confidence,
      rating,
      flagged,
      notes,
      time,
      quizQuestionId
    } = question;
    const selectedOptionIndex = question.selectedOptionIndex;
    const tagId =
      question.organSystemTagId ||
      question.QuestionTagBindings.filter(tag => tag.QuestionTag.organSystem)[0]
        .QuestionTag.id;

    const params = {
      time: Math.round(time / 1000),
      rating,
      flagged: !!flagged,
      notes,
      confidence,
      selectedOptionIndex,
      quizQuestionId,
      product: getState().app.product
    };

    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_submitResponse/`,
      {
        params,
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        }
      }
    )
      .then(res => {
        // TODO Add success/error dispatch
        if (res.data.data[0]) {
          const quiz = _.cloneDeep(getState().quiz);
          quiz.questions = quiz.questions.map(q =>
            Object.assign(q, { lastAttemptCorrect: isLastAttemptCorrect(q) })
          );
          quiz.correctCount = quiz.questions.reduce(
            (tot, q) => (q.lastAttemptCorrect ? tot + 1 : tot),
            0
          );
          if (state.filtered && state.filtered.quizzes) {
            const historyQuizIndex = state.filtered.quizzes.reduce(
              (idx, q, i) => (q.id === quiz.id ? i : idx),
              -1
            );
            const historyQuizCopy =
              _.cloneDeep(state.filtered.quizzes[historyQuizIndex]) || quiz;
            const questionIndex = _.findIndex(
              historyQuizCopy.questions,
              q => q.quizQuestionId === quizQuestionId
            );
            historyQuizCopy.questions.splice(questionIndex, 1, question);

            const updatedQuizzes = _.cloneDeep(state.filtered.quizzes);

            if (historyQuizIndex > -1) {
              updatedQuizzes.splice(historyQuizIndex, 1, historyQuizCopy);
            } else {
              updatedQuizzes.unshift(quiz);
            }

            dispatch({
              type: ACTIONS.TYPES.APP.FETCH_FILTERED_SUCCESS,
              history: { quizzes: updatedQuizzes }
            });
          }

          Object.assign(quiz.questions[quiz.currentQuestionIndex], {
            aqsId: res.data.data[0].attributes.aqsId
          });
          dispatch({ type: ACTIONS.TYPES.QUIZ.UPDATE_QUIZ, quiz });
          const app = Object.assign(_.cloneDeep(getState().app), {
            currentQuiz: quiz
          });
          dispatch({ type: ACTIONS.TYPES.APP.UPDATE_APP, app });
        }

        const tags = _.cloneDeep(getState().tags);
        const tagIndex = _.findIndex(tags, t => t.id === tagId);
        const correctResponse =
          question.options[selectedOptionIndex].correctOption;

        Object.assign(tags[tagIndex], {
          accountTotalCount: tags[tagIndex].accountTotalCount + 1,
          accountCorrectCount: correctResponse
            ? tags[tagIndex].accountCorrectCount + 1
            : tags[tagIndex].accountCorrectCount
        });
        dispatch({ type: ACTIONS.TYPES.TAG.UPDATE, tags });
      })
      .catch(err => console.log(err));
  };
}

export function getOptionStats(question) {
  return (dispatch, getState) => {
    dispatch({ type: ACTIONS.TYPES.QUESTION.GET_OPTION_STATS });
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/_questionStats/`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        },
        params: { question }
      }
    ).then(res => {
      return dispatch({
        type: ACTIONS.TYPES.QUESTION.GET_OPTION_STATS_SUCCESS,
        optionStats: res.data.data[0].attributes.stats.answerCounts
          .filter(o => o.selectedOptionIndex !== null)
          .reduce(
            (acc, o) =>
              Object.assign(acc, {
                total: acc.total + parseInt(o.count, 10),
                [o.selectedOptionIndex]: parseInt(o.count, 10)
              }),
            { total: 0 }
          )
      });
    });
  };
}

function isLastAttemptCorrect(q) {
  const isNull =
    q.selectedOptionIndex === undefined ||
    q.selectedOptionIndex === null ||
    !q.options[q.selectedOptionIndex];

  if (!isNull) {
    return q.options[q.selectedOptionIndex].correctOption;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/actions/stats.js